import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-baa',
  templateUrl: './baa.component.html',
  styleUrls: ['./baa.component.scss']
})
export class BaaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
